import styled from 'styled-components';

const FormInputsContainerStyled = styled.div`
  display: grid;
  margin-bottom: 20px;
  gap: 10px;
  grid-template-columns: 125px auto;
  @media (max-width: 767px) {
    width: 95dvw;
    grid-template-columns: 70px 1fr;
    & input {
      padding: 5px !important;
    }
  }
`;

export default FormInputsContainerStyled;
